import type { AuthProfile } from "./types";

const PORTAL_OPERATOR_ROLES = new Set(["admin", "worker"]);

/** Returns true when the signed-in profile can manage portal submissions. */
export function isVerifiedPortalOperator(
  profile: AuthProfile | null,
  isApproved: boolean,
): boolean {
  return (
    isApproved &&
    profile?.approval_status === "approved" &&
    profile.is_active === true &&
    typeof profile.role === "string" &&
    PORTAL_OPERATOR_ROLES.has(profile.role)
  );
}
